import { useEffect } from 'react'
import { useSelector, useDispatch } from "react-redux";

import {
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from '@mui/material';

import CloseIcon from "@mui/icons-material/Close";

import { fetchTrainingCenterFileById } from "../../../Actions";



const ViewImageDialog = ({ imgMeta, isOpen, closeHandler }) => {
  const dispatch = useDispatch();
  const trainersReducer = (state) => state.trainersReducer;

  const { trainingCenterFile, fetchingTrainingCenterFile } =
    useSelector(trainersReducer);

  useEffect(() => {
    dispatch(fetchTrainingCenterFileById(imgMeta.id));
  }, [imgMeta, dispatch]);

  return (
    <Dialog open={isOpen} onClose={closeHandler}>
      <DialogTitle style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
      }}>
        {imgMeta.name}
        <IconButton sx={{ml: 16}} onClick={closeHandler}>
          <CloseIcon />
        </IconButton>
      
      </DialogTitle>
      <DialogContent>
        {fetchingTrainingCenterFile ? (
          <CircularProgress />
        ) : (
          <img alt="Training Center File" src={trainingCenterFile} />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ViewImageDialog;